<template>
  <div class="scheduling-content">
    <div class="s-filter-box">
      <a-form layout="inline" :model="form">
        <a-form-item>
          <a-radio-group v-model:value="pressOperation" button-style="solid">
            <a-radio-button
              v-for="item in pressOperationItems"
              :key="item.text"
              :value="item.value"
            >
              {{ item.text }}
            </a-radio-button>
          </a-radio-group>
        </a-form-item>
        <a-divider
          type="vertical"
          v-if="pressOperation === 0 || pressOperation === 2"
          style="height: 32px; margin-right: 30px"
        ></a-divider>
        <a-form-item v-if="pressOperation === 0">
          <a-input-search
            v-model:value="formBatchId"
            placeholder="Input Batch ID"
            @search="deleteBatch"
          >
            <template #enterButton>
              <a-button
                :loading="deleteBatchLoading"
                :disabled="!(getData.length && formBatchId)"
              >
                Batch Delete
              </a-button>
            </template>
          </a-input-search>
        </a-form-item>
        <a-form-item v-if="pressOperation === 2">
          <a-space>
            <a-button @click="selectAll()">Select All</a-button>
            <a-button
              @click="cancelSelect()"
              :disabled="selectedTag.length === 0"
            >
              Cancel Select
            </a-button>
            <a-button
              type="danger"
              :loading="deleteLoading"
              @click="deleteSelect"
              :disabled="selectedTag.length === 0"
            >
              Delete
            </a-button>
          </a-space>
        </a-form-item>
      </a-form>
      <div class="btn-right">
        <a-popconfirm ok-text="Find" @confirm="find" @cancel="filterCancel">
          <template #icon></template>
          <template #title>
            <a-form :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
              <a-form-item label="Status">
                <a-select v-model:value="form.shipStatus" style="width: 100%">
                  <a-select-option
                    :key="item.text"
                    :value="item.value"
                    v-for="item in statusItems"
                  >
                    {{ item.text }}
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="Route ID">
                <a-select
                  v-model:value="form.routeId"
                  mode="multiple"
                  style="width: 100%"
                  :max-tag-count="1"
                  placeholder="Route ID"
                >
                  <a-select-option
                    :key="item.routeId"
                    :value="item.routeId"
                    v-for="item in routeIdItems"
                  >
                    {{ item.routeId }}
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="Model Name">
                <a-select
                  v-model:value="form.modelName"
                  mode="multiple"
                  style="width: 100%"
                  :max-tag-count="1"
                  placeholder="Modal Name"
                >
                  <a-select-option
                    :key="item"
                    :value="item"
                    v-for="item in modelNameItems"
                  >
                    {{ item }}
                  </a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item label="Range">
                <a-range-picker
                  class="range-w"
                  v-model:value="form.dateRange"
                  valueFormat="YYYY-MM-DD"
                  style="width: 100%"
                />
              </a-form-item>
              <a-form-item label="PO">
                <a-input
                  v-model:value="form.poNumber"
                  placeholder="PO Number"
                  allowClear
                  style="width: 100%"
                ></a-input>
              </a-form-item>
            </a-form>
          </template>
          <a-button type="link" :class="{ sel: isFormModify }">
            <template #icon>
              <filter-outlined />
            </template>
            Filter
          </a-button>
        </a-popconfirm>
        <a-divider type="vertical" />
        <a-button type="link" @click="doload()">
          <template #icon>
            <download-outlined />
          </template>
          Export
        </a-button>

        <a-divider type="vertical" />
        <a-button type="link" @click="find()">
          <template #icon>
            <reload-outlined />
          </template>
          Refresh
        </a-button>
      </div>
    </div>
    <CardListAdjustment
      :data-list="getData"
      :sort-name="form.timeFilter"
      :press-status="pressOperation"
      @sortDateChange="onSortChange"
      @needRefresh="ssInit"
      @onSelectChange="selectChange"
      ref="cardRef"
    ></CardListAdjustment>
  </div>
</template>

<script setup>
  import request from '@/utils/request'
  import {
    FilterOutlined,
    DownloadOutlined,
    ReloadOutlined,
  } from '@ant-design/icons-vue'
  import { ref, computed, provide } from 'vue'
  import { useStore } from 'vuex'
  import { message } from 'ant-design-vue'
  import dayjs from 'dayjs'
  import CardListAdjustment from './components/card-list-adjustment.vue'
  import { deepClone, isObjectValueEqual } from '@/utils'
  import { baseURL } from '@/config'

  const store = useStore()
  const netGroup = computed(() => store.getters['user/currentNetGroup'])
  const currentSystem = computed(() => store.getters['user/currentSystem'])
  // start 过滤条件================================================
  const formBatchId = ref('')
  const deleteBatchLoading = ref(false)
  const deleteBatch = function () {
    //删除batchId
    if (formBatchId.value) {
      deleteBatchLoading.value = true
      //可以提交
      request({
        url: '/api/shipment/batchDelDelivery',
        method: 'post',
        data: formBatchId.value,
      })
        .then(() => {
          message.success('Delete Batch Success!').then(() => {
            ssInit()
            formBatchId.value = ''
          })
        })
        .finally(() => {
          deleteBatchLoading.value = false
        })
    } else {
      message.warning('请填写正确的Batch ID！')
    }
  }
  const selectedTag = ref([])
  const cardRef = ref(null)

  const selectAll = () => {
    cardRef.value.selectAll()
  }
  const cancelSelect = () => {
    cardRef.value.cancelSelect()
  }
  const pressOperationItems = ref([
    { text: 'Delivery Unit', value: 0 },
    { text: 'Delete DU', value: 1 },
    { text: 'Select', value: 2 },
  ])

  const pressOperation = ref(0)
  const start = dayjs().subtract(3, 'month').format('YYYY-MM-DD')
  const end = dayjs().add(3, 'month').format('YYYY-MM-DD')
  const defaultForm = {
    shipStatus: '3',
    routeId: [],
    timeFilter: 'planPickupDate',
    poNumber: '',
    modelName: [],
    dateRange: [start, end],
  }
  const form = ref(deepClone(defaultForm))
  const statusItems = ref([{ text: 'Not COMPLETED', value: '3' }])
  const getShipStatus = async function () {
    const { body } = await request({
      url: '/api/shipment/getShipStatus',
    })
    statusItems.value = statusItems.value.concat(body)
  }

  const routeIdItems = ref([])
  const getRouteIds = async function () {
    const { body } = await request({
      url: '/api/shipment/getRouteIds',
    })
    routeIdItems.value = body || []
  }
  provide(
    'routeItems',
    computed(() => routeIdItems.value)
  )
  const modelNameItems = ref([])
  const getModelNames = async function () {
    const { body } = await request({
      url: '/api/shipment/getModelNames',
    })
    modelNameItems.value = body || []
  }
  const init = () => {
    getRouteIds()
    getShipStatus()
    getModelNames()
  }
  init()

  // 下载
  const doload = () => {
    const { routeId, shipStatus, poNumber, timeFilter, dateRange } = form.value
    let url = `${baseURL}/api/shipment/exportDeliveryUnit?current-system=${
      currentSystem.value
    }&netGrp=${
      netGroup.value
    }&shipStatus=${shipStatus}&routeId=${routeId.join()}&poNumber=${poNumber}&timeFilter=${timeFilter}&start=${dayjs(
      dateRange[0]
    ).valueOf()}&end=${dayjs(dateRange[1]).add(1, 'day').valueOf() - 1}`
    window.location.href = url
  }
  const deleteLoading = ref(false)
  const deleteSelect = async function () {
    //删除选中
    deleteLoading.value = true
    var selectedTagObj = selectedTag.value.map((item) => {
      return { id: item.id }
    })
    try {
      await cardRef.value.fnDelDelivery(selectedTagObj)
      deleteLoading.value = false
    } catch (e) {
      console.log(e)
      deleteLoading.value = false
    }
  }
  // end 过滤条件=========================================================

  // start 主体内容================================================
  const getData = ref([])
  const ssInit = async () => {
    const hide = message.loading('Loading……', 0)
    const rawData = { ...form.value }
    rawData.start = dayjs(form.value.dateRange[0]).valueOf()
    rawData.end = dayjs(form.value.dateRange[1]).add(1, 'day').valueOf() - 1
    rawData.modelName = rawData.modelName.join()
    rawData.routeId = rawData.routeId.join()
    rawData.netGrp = netGroup.value
    delete rawData.dateRange
    try {
      const { body } = await request({
        url: '/api/shipment/findDeliveryView',
        params: rawData,
      })
      getData.value = body

      hide()
    } catch (e) {
      hide()
      getData.value = []
    }
  }
  ssInit()

  const find = () => {
    ssInit()
  }
  const filterCancel = () => {
    form.value = deepClone(defaultForm)
    ssInit()
  }
  const isFormModify = computed(() => {
    return !isObjectValueEqual(form.value, defaultForm)
  })
  const onSortChange = (v) => {
    form.value.timeFilter = v
    ssInit()
  }
  const selectChange = (v) => {
    selectedTag.value = v
  }
  // end 主体内容=========================================================
</script>

<style lang="less" scoped>
  @import './less/index.less';
  .s-filter-box {
    padding: 10px;
    background: #f2f3f5;
    border-bottom: 1px solid #dbdcdc;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .sel {
    color: red;
  }
</style>
